import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { RehydrationService } from './modules/services/rehydration.service';
import { AuthService } from './modules/services/auth.service';
import { Router, RouterOutlet } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HeaderComponent } from './modules/components/header/header.component';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { filter } from 'rxjs/operators';
import { EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';

@Component({
  standalone: true,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, HeaderComponent]
})
export class AppComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private pageShowHandler = (event: PageTransitionEvent) => {
    if (event.persisted) {
      this.authService.isLoggedIn()
        .pipe(takeUntil(this.destroy$))
        .subscribe(isLoggedIn => {
          if (!isLoggedIn) {
            this.router.navigateByUrl('/login');
          }
        });
    }
  };

  constructor(
    private rehydrationService: RehydrationService,
    private authService: AuthService,
    private router: Router,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService
  ) {
  }

  ngOnInit() {
    // Handle MSAL redirect observable (critical for standalone components)
    this.msalService.handleRedirectObservable()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (result) => {
          if (result) {
            console.log('Redirect result:', result);
          }
        },
        error: (error) => console.error('Error handling redirect:', error)
      });

    this.rehydrationService.rehydrateAuthState();

    // Listen for browser back/forward navigation
    window.addEventListener('pageshow', this.pageShowHandler);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();

    // Clean up event listener
    window.removeEventListener('pageshow', this.pageShowHandler);
  }
}
